/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlUserContactInfoResponse } from './ControlUserContactInfoResponse';
import {
    ControlUserContactInfoResponseFromJSON,
    ControlUserContactInfoResponseFromJSONTyped,
    ControlUserContactInfoResponseToJSON,
} from './ControlUserContactInfoResponse';

/**
 * 
 * @export
 * @interface ControlGetContactsResponse
 */
export interface ControlGetContactsResponse {
    /**
     * 
     * @type {Array<ControlUserContactInfoResponse>}
     * @memberof ControlGetContactsResponse
     */
    contacts: Array<ControlUserContactInfoResponse>;
    /**
     * 
     * @type {number}
     * @memberof ControlGetContactsResponse
     */
    total: number;
}

/**
 * Check if a given object implements the ControlGetContactsResponse interface.
 */
export function instanceOfControlGetContactsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contacts" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ControlGetContactsResponseFromJSON(json: any): ControlGetContactsResponse {
    return ControlGetContactsResponseFromJSONTyped(json, false);
}

export function ControlGetContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetContactsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(ControlUserContactInfoResponseFromJSON)),
        'total': json['total'],
    };
}

export function ControlGetContactsResponseToJSON(value?: ControlGetContactsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contacts': ((value.contacts as Array<any>).map(ControlUserContactInfoResponseToJSON)),
        'total': value.total,
    };
}

